<template>
    <div style="background:white" class="ve-list-page">
        <div style="display:flex;line-height:25px ;  "> 
            <div  class="oneMenu" @click="itemClick('one')">
                <div style="margin-left:0px" :class="{active: actitem==='one'}" >
                    <i class="iconfont icon-huizong" style="margin-left:4px;margin-right:5px"></i>{{ $LANG('1348', '预测单-汇总') }}</div>
            </div>
            <div  class="oneMenu" @click="itemClick('two')">
                <div style="margin-left:40px" :class="{active: actitem==='two'}" >
                    <i class="iconfont icon-a-baobiaoguanlibaobiao" style="margin-left:4px;margin-right:5px"></i>{{ $LANG('1347', '预测单-明细') }}</div>
            </div>
        </div> 
        <div v-show="actitem=='two'" class="ve-list-page__body">
            <ord-two></ord-two>
        </div>      
        <div v-show="actitem=='one'" style=" display:flex;   background:#fff;line-height:30px;height:40px ;border-bottom:2px solid #389;">
            <div style="min-width:1100px;display:flex;padding-top:3px">
                <div style="width:70px">
                    <i class="iconfont icon-xinzeng" style="color:#409EFF;font-size:14px;margin-right:5px;margin-left:8px;"></i>
                    <el-link :disabled="addBool" @click="addRec" :underline="false" ><span style="font-size:13px;margin-right:15px;">{{ $LANG('0138', '新增') }} </span></el-link>
                </div>    
                <div style="font-size:12px;line-height:30px; width:30px;margin-left:8px">{{ $LANG('0298', '字段') }}</div>
                <el-select v-model="selparam"  :placeholder="$LANG('1675', '请选择列名')" filterable size="small" style="width:120px;  ">
                    <span v-for="item in tabArr" :key='item.key'>
                        <el-option :label="item.title" :value="item.key" v-if="item.thide=='N'"></el-option>
                    </span>
                </el-select>
                <el-input :placeholder="input_hold" clearable  v-model="txtparam" @keyup.enter.native="qryTabData" size="small" style="width:300px; height:30px; ">
                    <el-select :placeholder="$LANG('1664', '请选择')" v-model="oper" slot="prepend"   style="width:100px; " >
                        <span v-for="item in operArr" :key='item.IDSEQ'>
                            <el-option :label="item.CNAME" :value="item.SUBNO" ></el-option>
                        </span>
                    </el-select>
                    <el-button size="small" slot="append" icon="el-icon-search" @click="qryTabData" ></el-button>
                </el-input>
                <el-dropdown @command="dropSel"   size="small" style="margin-left:5px;">
                    <el-button type="danger" size="small" style="height:31px">
                        {{ $LANG('0337', '更多') }}<i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown"  >
                        <el-dropdown-item icon="iconfont icon-daochu" command="expdata" style="line-height:40px;height:40px">{{ $LANG('0172', '导出数据') }}</el-dropdown-item>
                        <el-dropdown-item icon="iconfont icon-ziyuan" command="fldset" style="line-height:40px;height:40px">{{ $LANG('0683', '字段设置') }}</el-dropdown-item>
                        
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div> 
        <div v-show="actitem=='one'" style="width:100%" class="ve-list-page__body">
            <div class="ve-list-page__table">
            <ve-table :columns="vueCol" 
                    :table-data="tabData" 
                    :columnHiddenOption="columnHiddenOption"
                    style="margin-top:2px; "
                    :border-around="true"
                    :border-x="true" 
                    :border-y="true" 
                    :fixed-header="true"

                    row-key-field-name="IDSEQ"
                    :row-style-option="rowStyleOption"
                    :cell-style-option="cellStyleOption"
                    :max-height="tabHeight" 
                    :virtual-scroll-option="virtualScrollOption"
                    :scroll-width="0"
                    :footer-data="footerData"
                    :clipboardOption="{copy:true,paste:false,cut:false,delete:false}"
            
                    :column-width-resize-option="columnWidthResizeOption"
                    :cellSelectionOption="{enable: false,}"
                    id="pre_load"
                    ref="tableRef"
                >

            </ve-table>
            </div>
            <div style="margin-top:2px" class="ve-list-page__pagination">
                <ve-pagination
                    :total="dataCount"
                    :page-index="pageIndex"
                    :page-size="pageSize"
                    :page-size-option="pageList"
                    @on-page-number-change="pageNumberChange"
                    @on-page-size-change="pageSizeChange"
                />
            </div>
        </div>
        <!-- 明细资料 -->
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="drawer" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:36px;height:36px;font-size:15px;padding-left:5px;"><i class="iconfont icon-xuanze" style="margin-right:5px"></i>{{$route.meta.title}} ：{{ $LANG('0109', '明细资料') }}</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <div v-for="(gpitem,gpind) in formArr" :key="gpind" style="margin-bottom:10px;">
 
                    <div class="one-div">
                        <span class="oneRow">{{gpitem.gpnm}}</span>
                    </div>
                    <Form :model="mainRow" :label-width="120" ref="supForm"  label-position="right" inline  :rules="ruleValidate">  
                        <span v-for="(item,index) in gpitem.gplist" :key="index" >
                            <FormItem  :label="$translate.getColTitle(item, $store.state.lang)"  :class=" 'item-width'" :prop="item.FLDNO"  v-if="item.FHIDE==='N'">
                                <el-date-picker size="medium" :disabled="saveFlag||item.DISABLED=='Y'" type="date"  v-if="item.EDCSS==='date'" v-model="mainRow[item.FLDNO]" clearable value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>   
                                <el-input-number size="medium"  :disabled="saveFlag||item.DISABLED=='Y'"  v-else-if="item.EDCSS==='number'" v-model="mainRow[item.FLDNO]" style="width:100%" ></el-input-number>   
                                <el-checkbox size="medium" border v-else-if="item.EDCSS==='checkbox'" true-label="Y"  false-label="N" v-model="mainRow[item.FLDNO]" style="width:100%"></el-checkbox> 
                                <el-select :placeholder="$LANG('1664', '请选择')" size="medium" filterable :disabled="saveFlag" v-else-if="item.EDCSS==='select'" v-model="mainRow[item.FLDNO]"   style="width:100%">
                                    <el-option v-for="(item,index) in comboArr[item.FLDNO]" :key="index" :label="item.CNAME" :value="item.CODE"></el-option>
                                </el-select>
                                <el-select :placeholder="$LANG('1664', '请选择')" size="medium" :disabled="saveFlag" v-else-if="item.FLDNO==='ACTNO'" v-model="mainRow[item.FLDNO]"   style="width:100%">
                                    <el-option v-for="(item,index) in cashArr " :key="index" :label="item.ACCNM" :value="item.IDSEQ"></el-option>
                                </el-select>
                                <el-select :placeholder="$LANG('1664', '请选择')" size="medium" filterable v-else-if="item.key==='CLNTNO'" :disabled="saveFlag" style="width:100%" v-model="mainRow[item.FLDNO]">
                                    <el-row v-for="item in clntArr " :key="item.IDNO">
                                        <el-col :span="6">
                                            <el-option  :label="item.IDNO" :value="item.IDNO"></el-option>
                                        </el-col>
                                        <el-col :span="6">
                                            <el-option  :label="item.CLTYPENM" :value="item.IDNO"></el-option>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-option  :label="item.CLNTNM" :value="item.IDNO"></el-option>
                                        </el-col>
                                    </el-row>
                                </el-select>
              
                                <el-select :placeholder="$LANG('1664', '请选择')" size="medium" filterable v-else-if="item.key==='STAFFNM'" :disabled="saveFlag" style="width:100%" v-model="mainRow[item.FLDNO]">
                                    <el-row v-for="(item,index) in empArr " :key="index">
                                        <el-col :span="6">
                                            <el-option  :label="item.EMPNO" :value="item.USERNM"></el-option>
                                        </el-col>
                                        <el-col :span="11">
                                            <el-option  :label="item.DEPTNM" :value="item.USERNM"></el-option>
                                        </el-col>
                                        <el-col :span="7">
                                            <el-option  :label="item.USERNM" :value="item.USERNM"></el-option>
                                        </el-col>
                                    </el-row>
                                </el-select>
                                <el-input size="medium" :placeholder="item.HOLDER" type="text" v-else :disabled="item.DISABLED==='Y'?true:false||saveFlag "  v-model="mainRow[item.FLDNO]"></el-input>
                            </FormItem>
                        </span>
                    </Form>
                </div>
                <div class="one-div">
                    <span class="oneRow">{{ $LANG('1031', '预单明细') }}</span>
                    <el-link  :underline="false" @click="saleAdd" :disabled="saveFlag" style="margin-left:20px; color:#cc0000;font-size:12px">
                        【<i class="iconfont icon-xinzeng" style=" font-size:12px;margin-right:2px;margin-left:2px;color:#cc0000"></i>{{ $LANG('0087', '新增明细') }}】
                    </el-link> 
                </div>
                <el-table  :data="dtlData" 
                    border                            
                    size="small"
                    ref="refsale"
                    :min-height="300" 
                    style="margin-top:-9px"
                    :cell-style="{padding:'3px'}"
                    :height="dtlHeight"
                    cell-class-name="clearPadding"
                    :row-class-name="tabRowClass"
                    show-summary
                    :summary-method="getSummary"
                    class="custom-table-border"
                    highlight-current-row
                    @row-click="dtlClick" > 
                    <el-table-column :label="$LANG('0310', '序号')" width="60" type="index" ></el-table-column>
                    <el-table-column  v-for="(item,index ) in dtlCol.filter(item=>item.thide=='N')" :key="index"
                        :prop="item.key"
                        :label="item.title"
                        show-overflow-tooltip
                        :align="item.align"                                  
                        :sortable="item.sortable=='N'"
                        :min-width="item.width">
                        <template slot="header">
                            <span v-if="item.notnull=='Y'" style="color:red">{{item.title}}</span>
                            <span v-else >{{item.title}}</span>
                        </template> 
                        <template slot-scope="scope">
                            <span v-if ="saveFlag" >
                                <el-checkbox v-if="item.edcss=='checkbox'" disabled true-label="Y" false-label="N" v-model="scope.row[item.key]"></el-checkbox>
                                <span v-else-if="item.key=='ORDTY'" v-text="scope.row['ORDTYNM']"></span>
                                <span v-else-if="item.key=='MATTY'" v-text="scope.row['CMATTY']"></span>
                                <span v-else-if="item.key=='RATE'" v-text="scope.row['RATENM']"></span>
                                <span v-else v-text="scope.row[item.key]"></span>
                            </span>
                            <span v-else >                    
                                <el-select :placeholder="$LANG('1664', '请选择')" :ref="'pos'+scope.$index+item.key" size="mini" v-if="item.key=='ORDTY'" v-model="scope.row[item.key]">
                                    <el-option v-for="(item,index) in tyArr" :label="item.CNAME" :value="item.CODE" :key="index"></el-option>
                                </el-select>
                                <el-select :placeholder="$LANG('1664', '请选择')" :ref="'pos'+scope.$index+item.key" v-else-if="item.key==='RATE'" size="mini" v-model="scope.row[item.key]"   style="width:100%">
                                    <el-option v-for="(item,index) in taxArr" :key="index" :label="item.CNAME" :value="item.CODE"></el-option>
                                </el-select>
                                <el-select :placeholder="$LANG('1664', '请选择')" :ref="'pos'+scope.$index+item.key" v-else-if="item.key==='MATTY'" size="mini" v-model="scope.row[item.key]"   style="width:100%">
                                    <el-option v-for="(item,index) in matArr" :key="index" :label="item.CNAME" :value="item.SUBNO"></el-option>
                                </el-select>
                                <el-input   @focus="inputBtn(scope.row,scope.$index,item.key)" :ref="'pos'+scope.$index+item.key" @keyup.enter.native="nextLine(item.key,'enter' )" @keyup.down.native="nextLine(item.key,'down' )" @keyup.up.native="nextLine(item.key,'up' )" v-else-if="item.edcss=='button'" size="mini" v-model="scope.row[item.key]" style="width:100%"> </el-input>  
                                <el-input type="number" @input="qtyPrc(scope.row,scope.$index,item.key)" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue" @keyup.enter.native="nextLine(item.key,'enter','refpos')" @keyup.down.native="nextLine(item.key,'down','refpos')" @keyup.up.native="nextLine(item.key,'up','refpos')"  :ref="'pos'+scope.$index+item.key"   v-else-if="item.disabled=='N'&&item.edcss=='number'" size="mini" v-model="scope.row[item.key]" style="width:100%"> </el-input> 
                                <el-date-picker  :ref="'pos'+scope.$index+item.key" type="date" size="mini" v-else-if="item.edcss==='date'" v-model="scope.row[item.key]" :clearable="false" value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>  
                                
                                <el-input  @keyup.enter.native="nextLine(item.key,'enter','refpos')" @keyup.down.native="nextLine(item.key,'down','refpos')" @keyup.up.native="nextLine(item.key,'up','refpos')"  :ref="'pos'+scope.$index+item.key"   v-else-if="item.disabled=='N' " size="mini" v-model="scope.row[item.key]" style="width:100%"> </el-input> 
                                <span v-else  v-text="scope.row[item.key]" style="width:100%"> </span> 
                            </span>
                        </template>
                    </el-table-column> 
                    <el-table-column
                        fixed="right"
                        :label="$LANG('0330', '操作')"
                        align="center"
                        width="70">
                        <template slot-scope="scope">
                            <i class="iconfont icon-shanchu" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                            <el-link :disabled="saveFlag" @click="perDel(scope.row,scope.$index)" :underline="false"  ><span style="font-size:12px; ">{{ $LANG('0131', '删除') }}</span> </el-link>
                        </template>
                    </el-table-column>                        
                </el-table>
            </div>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                <span style="float:right">
                    <span :style="stfgColor">
                        <i class="iconfont" :class="stfgCss"  style="font-size:30px; margin-right:40px;height:35px;vertical-align:middle"></i>
                    </span>
                    <el-button type="info" @click="drawer=false" size="small"  icon="iconfont icon-shanchu">  {{ $LANG('0132', '取消') }}</el-button>
                    <el-button :disabled=" saveFlag"  @click="saveRec" size="small" type="primary" style="margin-left:30px;" icon="iconfont icon-baocun"  > {{ $LANG('0130', '保存') }} </el-button>
                </span>
            </div>
        </el-dialog>
        <!-- 提示框 -->
        <el-dialog v-dialogDrag :visible.sync="promptWin"  width="450px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('1442', '提示') }}</span>
            </div>
            <div style="line-height:30px;display:flex">
                <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
            </div>
            <span slot="footer"  >
                <el-button type="primary" size="small" @click="promptWin = false">{{ $LANG('1638', '确 定') }}</el-button>
            </span>
        </el-dialog>
        <!-- 引用选择框 -->
        <el-dialog  v-dialogDrag   :visible.sync="btnWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0997', '选择记录') }}</span>
            </div> 
            <pub-win v-bind:tabCol ="tableCol"  v-bind:v_table="v_table" v-bind:v_key2="v_key2" v-bind:v_value2="v_value2" @child-exit="btnWin=false" @child-sure="btnSure"></pub-win>                
        </el-dialog>
        <!-- 引用报表 -->
        <el-dialog  v-dialogDrag   :visible.sync="repDlg" width="550px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="6vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0059', '报表参数') }}</span>
            </div> 
            <rep-win v-bind:v_idno ="v_idno" v-bind:v_replist="v_replist" v-bind:v_corpid="v_corpid" @child-exit="repDlg=false" @child-sure="repShow"></rep-win>                
        </el-dialog> 
        <!-- report preview -->
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="repWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0063', '报表预览') }}</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <iframe :src="repUrl" frameborder="0" style="width: 100%; height: 100%"></iframe>
            </div>
        </el-dialog>
        <VeColumnConfigDialog
            :visible="fieldSettingDialog.visible"
            :rows="fieldSettingDialog.rows"
            :loading="fieldSettingDialog.loading"
            :error="fieldSettingDialog.error"
            :locked-field-keys="fieldSettingDialog.lockedFieldKeys"
            :drag-group-field="fieldSettingDialog.dragGroupField"
            :language="$store.state.lang"
            @update:visible="fieldSettingDialog.visible = $event"
            @change="updateFieldSettingsDraft"
            @confirm="saveFieldSettingsDialog"
            @reset="resetFieldSettingsDialog"
            @close="closeFieldSettingsDialog"
        />
    </div>  
</template>
<script>
import repWin from '../datamgt/repWin.vue'  
import pubWin from '../datamgt/pubwin.vue' 
import { getTabColOrData,getBaseData } from '../../api/user';
import { getDate } from '../../api/Select' 
import ordTwo from './sale_preord_two.vue' 
import { startWorkflowInstance } from '@/utils/workflowDesigner.js'
import createVeTableFieldSettingMixin from '@/utils/veTableFieldSettingMixin'
import VeColumnConfigDialog from '@/components/VeTable/VeColumnConfigDialog.vue'
//局部注册
export default {
    name:"sale_preord",
    mixins: [
        createVeTableFieldSettingMixin({
            settingFormId: '17435',
            fieldIdseq: '17435',
            fieldLstseq: '2076',
            mainColumnKey: 'tabArr',
            tableColumnKey: 'vueCol',
            initColumnKey: 'initCol',
            tableRef: 'tableRef',
            lockedFieldKeys: ['SMPNO'],
        })
    ],
    data () {
        return {
            matWin:false,
            smpWin:false,
            clntArr:[],
            drawer:false,
            repWin:false,
            dtlRow:{},
            saveFlag:false,
            input_hold:this.$LANG('1718', '请输入查询的值'),
            promptWin:false,
            prodWin:false,
            actitem:'one',
            prompt:'',
            stfgCss:'',
            v_row:{},
            stfgColor:'',
            mainRow:{},
            clntWin:false,
            taxArr:[],
            cashArr:[], // 
            disabled:false, //新增权限制
            stfgSet:'ALL',
            idseq:'', //菜单主键
            lstseq:'',//菜单主键
            ruleValidate:{},
            formArr:[],
            tabData:[], //表数据
            allData:[],
            tabArr:[], //表列
            dtlData:[], //明细数据
            dtlCol:[],
            oper:'like',
            comboArr:{},
            txtparam:'',
            selparam:'IDNO',
 
            delArr:[],
            rowIndex:'-1',
            v_url:'xuper_auth/getTableRecMany', //api请求路径
            v_formurl:'xuper_auth/getFormGroup', 
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') ,//api 请求密码
            v_admin:this.$cookies.get('v_admin') ,//api 请求密码
            v_usernm:this.$cookies.get('v_usernm'), //api 请求用户
            empArr:[],
            dataCount:0,
            operArr:[],
            pageIndex:1,
            goPage:'',
            notNull:[],
            current:1,
            tyArr:[],
            stfgBool:true,
            addBool:false, //新增,为true时--禁止
            editBool:false, //编辑,为true时--禁止
            delBool:false, //删除 ,为true时--禁止
            cfmBool:false, //审核 ,为true时--禁止
            cancelBool:false, //作废 ,为true时--禁止
            pageList: [50,500,1000],
            pageSize: 50,
            v_ratenm:'',
            saveTag:true, 
            v_exrt:1,
            v_table:'',
            tableCol :[],
            prodCol:[],
            v_key2 :'',
            v_value2 :'',
            v_key:'',
            btnWin:false,
            v_tabRow:{},
            v_tabIndex:'',
            matArr:[],
            chkIndex: 0,
            repDlg:false,
            v_idno:'',
            v_replist:[],
            repArr:[],
            repUrl:'',
            columnHiddenOption: {
                // default hidden column keys
                defaultHiddenColumnKeys: [],
            },
            rowStyleOption: {
                clickHighlight: true,
                
            },
            cellStyleOption: {
                bodyCellClass: ({ row, column, rowIndex }) => {
                    return "table-body-cell-class1" 
                },
                headerCellClass: ({column, rowIndex }) => {
                    if (column.field=='#'){
                        return "table-head-cell-class2"
                    }else{
                        return "table-head-cell-class" 
                    }
                },
                footerCellClass: ({ row, column, rowIndex }) => {
                    return "table-foot-cell-class";
                },
            },
            virtualScrollOption: { enable: false },
            v_inputrow:{},
            loadingInstance: null,
            v_sort:'asc',
            startRowIndex: 0,
            vueCol:[],
            initCol:[],
            footerData:[],
        }
    },
    mounted () { 
        //操作符
        getBaseData('xuper_auth/getBaseData','PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        })
        getBaseData('xuper_auth/getBaseData','PARENTNO','249','','','v_sys_base',' order by sortby').then(res=>{
            this.taxArr =res.result
        }); 
        //用户表单新增、编辑、审核、作废权限 :frmid: ID
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','17435','v_sys_user_priv','').then(res=>{           
            if (this.v_admin==='N') { //表示有权限控制
                let row =res.result[0]
                if (row.ISADD==='N'){ //新增
                    this.addBool=true
                }if (row.ISUPD==='N'){ //修改
                    this.editBool=true
                }if (row.ISDEL==='N'){ //删除
                    this.delBool=true
                }if (row.ISCFM==='N'){ //审核
                    this.cfmBool=true
                }if (row.ISCANCEL==='N'){ //作废
                    this.cancelBool=true
                }
            }
        })  
        //表单所以下拦框动态赋值
        this.comSelect()
        //人员资料
        getBaseData('xuper_auth/getBaseData','CORPID',this.v_corpid ,'isout','N','V_SYS_USER','').then(res=>{
            this.empArr =res.result
        })
        //资金账户选择
        getBaseData('xuper_auth/getBaseData','CORPID',this.v_corpid ,'','','v_ac_account',' and stfg=\'Y\'').then(res=>{
            this.cashArr =res.result
        })
        //表单资料分组 
        getTabColOrData(this.v_formurl,'v_sys_form_fld','idseq','17435','gpnm,gpsort','','lstseq','2076', ' order by gpsort').then((res) => {
                this.formArr = res.result             
        })
        getBaseData('xuper_auth/getBaseData','CORPID',this.v_corpid ,'','','v_bs_clnt',' order by cltype').then(res=>{
            this.clntArr =res.result
        })
        //动态生成表单验证规则
        getTabColOrData(this.v_url,'v_sys_form_fld','idseq','17435','LSTSEQ','2076','NOTNULL','Y').then((res) => {
            let ruleObj={}
            let ruleVal=[]
            this.notNull = res.result
            res.result.forEach(item => {
                let v_fldnm =this.$translate.getColTitle(item, this.$store.state.lang)
                let obj1={required:true,message:v_fldnm+this.$LANG('2051', '不能为空')}
                ruleVal =[]
                ruleVal.push(obj1)
                ruleObj[item.FLDNO]=ruleVal                  
            });
            this.ruleValidate =ruleObj
        })
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','17435','V_USER_MOD_REP','').then(res=>{
            this.repArr =res.result
        })
        getBaseData('xuper_auth/getBaseData','PARENTNO','399846','','','v_sys_base','').then(res=>{
            this.tyArr =res.result
        }) 
        getBaseData('xuper_auth/getBaseData','PARENTNO','16224','','','v_sys_base','').then(res=>{
            this.matArr =res.result
        }) 
    },
    computed: {
        dlgWidth: function() {
            return (window.innerWidth - 160) + 'px';
        }, 
        tabHeight: function() {
            return (window.innerHeight - 195) + 'px';
        }, 
        tabWidth: function() {
            return (window.innerWidth - 120) + 'px';
        }, 
        dtlHeight: function() {
            return (window.innerHeight - 380) + 'px';
        }, 
    },
    components: {
        pubWin,
        repWin,
        ordTwo,
        VeColumnConfigDialog,
    },
    created () {       
        if (this.v_username){ 
            //查询数据
            this.loadingInstance = this.$veLoading({
                target: document.querySelector("#pre_load"),
                name: "wave",
            })
            this.qryTabData()
            this.getTabField() //表列字段
    
        }else{
            let routeUrl = this.$router.resolve({
                path: '/login',
                query: {},
            });
            window.open(routeUrl.href, '_self');
        }
    },
    destroyed() {
        this.loadingInstance.destroy()
    },
    watch: {
 
    },
    methods: {
        itemClick(val){
            this.actitem =val     
        },
        getFootSum(){
            //累计数组中 接办数量的和
            let v_ttlqty =this.tabData.reduce((prev,cur)=>{return Number(prev) + Number(cur.QTY) },0)
 
            // footer data
            this.footerData =[
                {
                    rowKey: 0,
                    index: this.$LANG('0280', '合计'),
                    QTY: v_ttlqty.toLocaleString(),
                    //FQTY: v_ttlfqty.toLocaleString(),
                },
            ]
        } , 
        sortChange(params){
            let v_key=params.key ,v_edcss=''
            if (this.v_sort =='asc'){
                this.v_sort ='desc'
            }else if (this.v_sort =='desc'){
                this.v_sort ='asc'
            } 
            this.tabArr.some(item=>{
                if (item['key']==v_key){
                    v_edcss =item['edcss']
                }
            })
            this.tabData.sort((a, b) => {
                if (v_edcss =='number' ){
                    if (this.v_sort =='asc'){ //a == null ? -1 : b == null ? 1 : 0
                        return a[v_key] == null ? -1 : b[v_key] == null ? 1 :   a[v_key] -b[v_key]
                    }else if (this.v_sort =='desc'){
                        return b[v_key] == null ? -1 : a[v_key] == null ? 1 :  b[v_key] -a[v_key]
                    }else{
                        return 0
                    }
                }else{
                    let nameA = a[v_key]?a[v_key].toUpperCase():a[v_key]  
                    let nameB = b[v_key]?b[v_key].toUpperCase():b[v_key]     
                    if (this.v_sort =='asc'){
                        return nameA == null ? -1 : nameB== null ? 1 :  nameA > nameB ? -1 : 1
                    }else{
                        return nameA == null ? 1 : nameB== null ? -1 : nameA > nameB ? 1 : -1
                    }
                }
            })
        },
        enterDown(event){
            if (event.keyCode==13){
                this.qryTabData()
            }
        },
        inputChg(e,column){
            this.v_inputrow[column]=e.target.value
            this.v_row[column] =e.target.value
        },

        dropSel(val){
            if (val =='expdata'){ //导出数据
                //导出
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/report/GenExcel',
                    data: {p_idseq:'17435',p_lstseq:'2076',p_json:JSON.stringify(this.allData),p_action:'预测单'},
                    responseType:'blob' //关键，声明响应类型为二进制流
                }).then(response=>{ 
                    // 从响应头解析后端设置的文件名
                    // 创建Blob对象并触发下载  创建下载链接
                    const blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
                    const link = document.createElement('a');
                    link.href = URL.createObjectURL(blob)
                    link.download = this.$LANG('0510', '预测单')+'_'+getDate('full')+'.xls'
                    link.click()
                    URL.revokeObjectURL(link.href)

                })
            } else if (val =='fldset'){  //字段设置显示--隐藏
                this.openFieldSettingsDialog().catch(error => {
                    this.promptWin =true
                    this.prompt =error.message || this.$LANG('1225', '字段显示设置')
                })
            } 
        },
        //页号改变
        pageNumberChange(pageIndex) {
            this.pageIndex = pageIndex
            this.changePage(pageIndex)
        },
        pageSizeChange(pageSize) {
            this.pageIndex = 1
            this.pageSize = pageSize
            this.changePage(this.pageIndex)
        },
        rowShow(){
            Object.keys(this.v_row).forEach(item=>{
                this.v_row[item] =''
            })
            this.v_inputrow={}
            this.qryTabData()
        } ,
 
        repShow(row){
            if (!row['REPNO']){
                this.promptWin =true
                this.prompt =this.$LANG('1678', '请选择报表')
            }else{
                this.repWin =true
                this.repDlg =false
                this.repUrl =this.$store.state.repUrl+ row['REPNO']+'&p_corpid='+row['CORPID']+'&p_idno='+row['IDNO'] 
            }
        },
        //报表运行
        repBtn(row){
            this.repDlg =true
            this.v_idno =row['IDNO']
            this.v_replist =this.repArr
        },
        //表格行 按回车键 到下一行
        nextLine(key,val,reftab){ 
            if (val =='enter'){
                if (key =='RMK'){
                    this.chkIndex = this.chkIndex +1
                    let v_count=''
                    if (reftab=='refpos'){
                        v_count =this.dtlData.length
                    }
                    if (this.chkIndex >=v_count) {
                        this.chkIndex =0
                    }
                    this.$refs['refsale'].setCurrentRow(this.dtlData[this.chkIndex])
                    if (reftab=='refpos'){
                        this.$refs['pos'+this.chkIndex+'QTY'][0].focus()  
                    } 
                }else{
                    if (reftab=='refpos'){
                        let v_col = this.dtlCol.filter(item=>item.thide=='N'&&item.disabled=='N'&&item.edcss!=='checkbox')
                        v_col.some((item,index)=>{
                            if (item.key==key){
                               this.$refs['pos'+this.chkIndex+ v_col[index+1].key][0].focus()  
                            }
                        })
                    }
                }
            }else if (val =='down'){
                this.chkIndex = this.chkIndex +1
                if (reftab=='refpos'){
                    if (this.chkIndex >=this.dtlData.length) {
                        this.chkIndex =0
                    }
                    this.$refs['refsale'].setCurrentRow(this.dtlData[this.chkIndex])
                } 
                if (reftab=='refpos'){
                    this.$refs['pos'+this.chkIndex+key][0].focus()  
                }
            }else if (val =='up'){
                this.chkIndex = this.chkIndex -1
                if (this.chkIndex <=0) {
                    this.chkIndex =0
                }              
                if (reftab=='refpos'){
                    this.$refs['pos'+this.chkIndex+key][0].focus()  
                    this.$refs['refsale'].setCurrentRow(this.dtlData[this.chkIndex])
                } 
            }                    
        },
        btnSure(obj){
            if (this.v_key =='MATNO'){
                let v_prc =''
                if (this.mainRow['CRCY']== '4238') { //人民币
                    v_prc =obj['PRC']
                }else{
                    v_prc =obj['OUTPRC']
                }
                this.dtlData.splice(this.v_tabIndex,1, Object.assign(this.v_tabRow,{ MATNO:obj['IDNO'],PRC:v_prc,MATNM:obj['MATNM'],MATDESC:obj['MATDESC'],MATTYNM:obj['MATTYNM'],UNITNM:obj['UNITNM'],RATE:obj['TAXNUM']} ))
                this.$refs['pos'+ this.v_tabIndex+'QTY'][0].focus()  
                this.chkIndex =this.v_tabIndex
            } 
            this.btnWin =false
        },
        inputBtn(row,index, key){   
            this.v_key =key         
            if (key=='MATNO'){
                if (row['MATTY']){
                    this.v_tabRow =row
                    this.v_tabIndex =index
                    this.v_table ='v_bs_mat'
                    this.tableCol =this.prodCol
                    this.v_key2 ='modelno'
                    this.v_value2 = row['MATTY']
                    this.btnWin =true
                }else{
                    this.prompt =this.$LANG('1735', '请选择物品类别')
                    this.promptWin =true
                }
            }
        },
        //对指定列进行合计
        getSummary(param){
            const {columns ,data}=param
            const sums=[]
            columns.forEach((column,index)=>{
                if (index===0){
                    sums[index]=this.$LANG('0280', '合计')
                    return
                }
                const values =data.map(item=>Number(item[column.property]));
                if(column.property==='QTY'||column.property==='AMT'){
                    sums[index]=values.reduce((prev,curr)=>{ //为数组中每一个元素依次执行回调函数
                        const value=Number(curr)
                        if(!isNaN(value)){
                            return Number(Number(prev) +Number(curr) ).toFixed(1)
                        }else{
                            return prev
                        }
                    },'')
                }
            })
            return sums
        },
        qtyPrc(row,index,key){
            if (key=='PRC'|| key=='QTY' ){
                let v_amt=0
                if ( row['QTY'] && row['PRC']){
                    v_amt =(Number(row['QTY'])*Number( row['PRC'] )).toFixed(2)
                }
                this.dtlData.splice(index,1, Object.assign(row,{ AMT: v_amt} ))
            
            }
            this.$forceUpdate()
        },
 
        //产品选择
        matChoose(){
            if(this.dtlRow['MATTY']==='16225'){ //PRD
                this.prodWin=true
            }else if(this.dtlRow['MATTY']==='16226'){ //MAT
                this.matWin=true
            }else if(this.dtlRow['MATTY']==='16227'){ //SMP
                this.smpWin=true  
            }else{
                this.promptWin=true
                this.prompt=this.$LANG('1735', '请选择物品类别')
            }
            //选择货币与人民币兑换
            let v_dttm =this.mainRow['ORDDTTM'].substring(0,7)
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'crcy', p_value:this.mainRow['CRCY'],p_key2:'corpid',p_value2:this.v_corpid, p_cond: ' and dttm =\''+v_dttm+'\'',p_table:'V_CRCY'},
            }).then(res=>{ 
                if (res.result.length>0 ){
                    this.v_exrt =res.result[0]['EXRT']
                }else{
                    this.v_exrt =1
                }
            }) 
        },
 
        //表行点击事件
        rowClick(row){
            if (row['STFG']==='Y')  {  
                this.stfgColor='color:green'
                this.stfgCss='icon-yishenhe1'
            }else if (row['STFG']==='X')  {  
                this.stfgColor='color:red'
                this.stfgCss='icon-yizuofei'
            }else{
                this.stfgColor='color:gray'
                this.stfgCss='icon-weishenhe3'
            }
        },
        dtlClick(row){
            this.chkIndex =row.index
        },
        tabRowClass({row,rowIndex}){  //为 table数据添加 index 字段
            row.index =rowIndex
        },
 
        perDel(row,index){
            this.$confirm(this.$LANG('1594', '你确定要删除此记录吗'),this.$LANG('1442', '提示'),{
                confirmButtonText: this.$LANG('1638', '确定'),
                cancelButtonText:this.$LANG('0132', '取消'),
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                this.dtlData.splice(index,1)
                this.delArr.push(row)
            }).catch(()=>{})
        },
        saleAdd(){
            let v_row ={}
            this.dtlCol.forEach(item=>{
                v_row[item.key] =''
            })
            v_row={'MATTY':'PRD','ORDTY':'399847','ORDTYNM':'正式订单' }
            this.dtlData.push(v_row)
 
            this.$nextTick(()=>{
                this.$refs['refsale'].doLayout()
            }) 
            
        },
 
        //动态赋值下拉框
        comSelect(){  
            this.$axios({
                method:'post', 
                url: 'xuper_auth/getBaseData' ,
                data:{p_table:'v_sys_form_fld',p_key:'idseq',p_value:'17435',p_cond:' and lstseq in (2076,2077)' ,p_key3:'edcss',p_value3:'select'},
            }).then(res =>{
                if (res.result.length>0){
                    for(let k=0;k<res.result.length;k++){
                        getBaseData('xuper_auth/getBaseData','parentno',res.result[k].COMBO ,'','','v_sys_base','').then(res2=>{
                            this.comboArr[res.result[k].FLDNO] =res2.result
                        })
                    }
                }
            })  
        },
        //保存记录
        saveRec(){
            var vm =this 
            this.notNull.some(item=>{  //forEach 没找到跳出循环，some：return true 跳出lop ,every：return false 跳出
                if (!this.mainRow[item.FLDNO] ){
                    this.stfgBool =false 
                    this.promptWin=true
                    this.prompt=this.$translate.getColTitle(item, this.$store.state.lang)+this.$LANG('2051', '不能为空')
                    return true
                }else{
                    this.stfgBool =true  
                }
            })
            const v_arr  =Array.from(new Set(this.dtlData.map(item=>item.MATNO))) 
            if (this.dtlData.length>0 && v_arr.length<this.dtlData.length ){
                this.promptWin =true
                this.prompt =this.$LANG('1921', '明细记录中已存在相同的产品编码,请核查')
            }else {
                //发起保存请求   
                if (this.stfgBool && this.saveTag ) {  
                    this.saveTag =false  
                    let obj_ ={},amt_=0,actamt_=0 ,v_matFlag=false ,v_qtyFlag=false
                    //汇总明细金额
                    this.dtlData.forEach(item=>{    
                        if(item['AMT']){
                            amt_=Number(amt_)+Number(item['AMT'])
                        }
                        if (!item['MATNO']){
                            v_matFlag =true
                        }
                        if (!item['QTY']){
                            v_qtyFlag =true
                        }
                    })
                    if (this.dtlData.length==0){
                        this.promptWin =true
                        this.prompt =this.$LANG('0109', '明细资料')+this.$LANG('2051', '不能为空')
                    }else if (v_matFlag){
                        this.promptWin =true
                        this.prompt =this.$LANG('1267', '明细资料中的')+this.$LANG('0547', '产品编码')+this.$LANG('2051', '不能为空')
                    }else if (v_qtyFlag){
                        this.promptWin =true
                        this.prompt =this.$LANG('1267', '明细资料中的')+this.$LANG('0333', '数量')+this.$LANG('2051', '不能为空')
                    }else {
                        //应收金额
                        if(this.mainRow['DISFEE']) {
                            actamt_=Number(amt_)-Number(this.mainRow['DISFEE'])
                        }else{
                            actamt_=Number(amt_)
                        }    
                        Object.assign(obj_,vm.mainRow,{ 'CORPID':this.v_corpid,AMT:amt_,ACTFEE:actamt_}) 
                        this.$axios({
                            method: 'post',
                            url:'xuper_auth/formOneSave',
                            data: {p_json:JSON.stringify(obj_), p_table:'ord',frmid:'17435'},
                        }).then(res=>{      
                            if(res.result ==='OK')  {  
                                //预单明细保存：批量保存  res.idseq
                                this.$axios({   
                                    method: 'post',
                                    url:'xuper_auth/batDtlSave2',
                                    data: {p_json:JSON.stringify(this.dtlData), p_table:'orditm',p_idseq:res.idseq,p_action:'S' },
                                }).then(res=>{
                                    if (res.code!=='200'){
                                        this.promptWin=true
                                        this.prompt=res.result
                                    }
                                })
                                //明细删除
                                if (this.delArr.length>0) {
                                    this.$axios({   
                                        method: 'post',
                                        url:'xuper_auth/batDtlSave2',
                                        data: {p_json:JSON.stringify(this.delArr), p_table:'orditm',p_idseq:res.idseq,p_action:'D' },
                                    })
                                }   
        
                                vm.drawer =false   
                                vm.qryTabData()
                            }else{
                                this.promptWin=true
                                this.prompt=res.result
                            }        
                        }) 
                    }
                }
            }
        },
        //状态审核
        recSet(row,val,text){
            const actionLabels = {
                '确认': this.$LANG('0364', '确认'),
                '作废': this.$LANG('0257', '作废'),
                '弃认': this.$LANG('0314', '弃认'),
                '审核': this.$LANG('0134', '审核'),
                '弃审': this.$LANG('0137', '弃审'),
            }
            const actionLabel =actionLabels[text] || text
            let v_bool =false
            if( text=='弃审'){
                if (this.v_usernm !==row['CHKUSER']){
                    v_bool =true
                }
            }
            if (v_bool){
                this.promptWin =true
                this.prompt =this.$LANG('0028', '当前用户:')+this.v_usernm+this.$LANG('1049', ' 与审核用户:')+row['CHKUSER']+this.$LANG('1646', ' 不同时不能弃审')
            }else{
                this.$confirm(this.$LANG('1564', '你确定要')+actionLabel+this.$LANG('1566', '此行记录吗'),this.$LANG('1442', '提示'),{
                    confirmButtonText: this.$LANG('1638', '确定'),
                    cancelButtonText:this.$LANG('0132', '取消'),
                    customClass:'messageBox', 
                    showClose:false,
                    closeOnClickModal:false,
                    closeOnPressEscape:false,
                    type:'info',
                }).then(()=>{
                    var vm=this,v_cond='' ,v_chkdttm='',v_chkuser='',v_cfmdttm='',v_cfmuser='' 
                    if (val =='K') {
                        if(text=='弃审'){
                            v_cfmdttm =''
                            v_cfmuser =''
                        }else{
                            v_cfmdttm =getDate('full')
                            v_cfmuser =this.v_usernm
                        }
                        v_cond =' set stfg=\''+val+'\',appuser=\''+v_cfmuser+'\',appdttm=\''+v_cfmdttm+'\',chkuser=null,chkdttm=null'
                    }else if (val =='Y'){
                        v_chkdttm =getDate('full')
                        v_chkuser =this.v_usernm
                        v_cond =' set stfg=\''+val+'\',chkuser=\''+v_chkuser+'\',chkdttm=\''+v_chkdttm+'\''
                    }else{
                        v_chkuser='',v_chkdttm='',v_cfmuser='',v_cfmdttm=''
                        v_cond =' set stfg=\''+val+'\',chkuser=\''+v_chkuser+'\',chkdttm=\''+v_chkdttm+'\',appuser=\''+v_cfmuser+'\',appdttm=\''+v_cfmdttm+'\''
                    }
                    this.$axios({
                        method: 'post',
                        url:'xuper_auth/updateRec',
                        data: {p_key:'idseq',p_value:row.IDSEQ,p_table:'ord',p_cond: v_cond },
                    }).then(res=>{      
                        if(res.code =='200')  {           
                            vm.qryTabData()     
                        }else{
                            this.promptWin=true
                            this.prompt=res.message
                        }        
                    }) 
                    //发起审批时
                    if (val =='K'){
                        // 调用工作流启动函数
                        startWorkflowInstance({
                            flowId: '17435',
                            businessId: row.IDSEQ, // 使用文件ID作为业务单据ID
                            actualInitiator: {empnm:this.v_usernm,empno:this.v_username,corpid:this.v_corpid},
                            component: this,
                            axios: this.$axios,
                            baseUrl: '',
                            // 微信消息相关参数
                            docType: '预测单', // 单据类型
                            DIRNM: row.CLNTNM, // 项目名称，使用文件名
                            CNAME: row.PRDDESC,
                            businessData: {
                                flowType: 3,
                                qty: null,
                                amt: row['TTLAMT'],
                            },
                            jumpUrl: window.location.href // 跳转URL，使用当前页面地址
                        })
                    }else if( text=='弃认'){ // 要把  SYS_FLOW_APPUSER 的状态为P 改为N
                        this.$axios({
                            method: 'post',
                            url:'xuper_auth/updateRec',
                            data: {p_key:'IDSEQ',p_value:row['IDSEQ'],p_table:'SYS_FLOW_APPUSER',p_cond:' set stfg=\'N\'',p_where:' and stfg=\'P\''},
                        }).then(res=>{
                            // 在日志表中 插入 一条 弃认记录
                            let v_obj={IDSEQ:row['IDSEQ'],LSTSEQ:'',EMPNO:this.v_username,EMPNM:this.v_usernm,APPDTTM:getDate('full'),STFG:'N',LOGTY:'R',RMK:'发起人 弃认'}
                            this.$axios({
                                method: 'post',
                                url:'xuper_auth/tableBodySave',
                                data: {p_json:JSON.stringify(v_obj), p_table:'SYS_FLOW_APPLOG' },
                            }).then(res=>{   
                            })
                        })
                    }else if( text=='弃审'){ // 要把  SYS_FLOW_APPUSER 的状态为P 改为N
                        this.$axios({
                            method: 'post',
                            url:'xuper_auth/updateRec',
                            data: {p_key:'IDSEQ',p_value:row['IDSEQ'],p_table:'SYS_FLOW_APPUSER',p_cond:' set stfg=\'N\'',p_where:' and stfg=\'Y\' and iscc=0'},
                        }).then(res=>{
                            // 在日志表中 插入 一条 弃认记录
                            let v_obj={IDSEQ:row['IDSEQ'],LSTSEQ:'',EMPNO:this.v_username,EMPNM:this.v_usernm,APPDTTM:getDate('full'),STFG:'N',LOGTY:'R',RMK:'发起人 弃审'}
                            this.$axios({
                                method: 'post',
                                url:'xuper_auth/tableBodySave',
                                data: {p_json:JSON.stringify(v_obj), p_table:'SYS_FLOW_APPLOG' },
                            }).then(res=>{   
                            })
                        })
                    } 
                }).catch(()=>{})
            }
        },
        //订单明细
        getOrdList(cond){
            this.loadingInstance.show()       
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'ordty', p_value:'PRE',p_key2:'corpid', p_value2:this.v_corpid,p_cond:cond+' order by '+this.selparam+' desc',p_table:'V_ord'},
            }).then(res=>{ 
                if (res.code==='200'){
                    this.allData =res.result
                    this.initPage() 
                    this.$nextTick(() => { //有固定列时 查询后重新布局
                        this.getFootSum()
                        this.loadingInstance.close()    
                    })
                }else{
                    this.promptWin=true
                    this.prompt=res.result
                }
                
            }) 
        },
        //查询明细数据
        getDtlData(idseq){
            getTabColOrData(this.v_url,'V_orditm','idseq',idseq,'','','','',' order by adddttm desc').then((res) => {
                this.dtlData=[]
                this.dtlData =res.result  
                this.$nextTick(()=>{
                    this.$refs['refsale'].doLayout()
                })
            })
        },
 
        //初始化查询页条数
        initPage(){
            //产品明细
            this.dataCount =this.allData.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allData.length < this.pageSize){
                this.tabData = this.allData          
            }else{
                this.tabData =this.allData.slice(0,this.pageSize) //返回选定元素的子数组，不包含结尾元素
            }
        },
        //表格页面导航
        changePage(index){
            var _start = ( index - 1 ) * this.pageSize;
            var _end = index * this.pageSize
            this.current =index
            this.tabData = this.allData.slice(_start,_end)
            this.getFootSum()
        },
 
        editRec(row,val){
            if (val==='Y'){  //仅查看
                this.saveFlag=true
            }else{
                if (row.STFGNM==='待审核'){
                    this.saveFlag=false
                }else{
                    this.saveFlag=true
                }
            }
            this.saveTag =true
            this.mainRow =JSON.parse(JSON.stringify(row))
            this.drawer=true     
            this.getDtlData(row.IDSEQ)      
        },
        getRowKey(row){
            return row.IDSEQ
        },
        //查询
        qryTabData(){
            let v_cond ='' , v_oper='' ,v_edcss='' 
            if (this.selparam){ //列1
                this.tabArr.some(item=>{  
                    if (item['key']==this.selparam){
                        v_edcss =item['edcss']
                    }
                })
                if (this.oper==='like'){
                    v_cond=v_cond+' and  '+this.selparam+' like  \'%' + this.txtparam+'%\' '
                } else{
                    if (this.txtparam){
                        if (v_edcss=='number'){
                            v_cond=v_cond+' and  '+this.selparam  +this.oper+ this.txtparam
                        }else {
                            v_cond=v_cond+' and '+this.selparam  +this.oper+' \''+this.txtparam+'\' '
                        }
                    }
                }               
            }
            Object.keys(this.v_row).filter(item=>item.indexOf('#OPER')<0).forEach(item=>{
                if (this.v_row[item] ){
                    this.tabArr.some(it=>{
                        if (it['key']== item){
                            v_edcss =it['edcss']
                        }
                    })
                    if (this.v_row[`#OPER`+item]){
                        v_oper =this.v_row[`#OPER`+item]
                    }
                    if (!v_oper){
                        v_oper ='like'
                    }
                    if (v_oper =='like'){
                        v_cond =v_cond +' and  '+item+'  like \'%'+ (this.v_row[item]).trim()+'%\''
                    }else{
                        if (v_edcss =='number' ){
                            v_cond =v_cond +' and '+item+ v_oper +  this.v_row[item] 
                        }else if ( v_edcss=='date'){
                            v_cond =v_cond +' and '+item + v_oper +'\''+this.v_row[item] +'\''          
                        }else{
                            v_cond =v_cond +' and  '+item +v_oper+'\''+ (this.v_row[item]).trim()+'\''  
                        }
                    }
                }
            })
            this.getOrdList( v_cond)
        },
        //新增客户
        addRec(){
            this.drawer =true
            this.stfgCss='icon-weishenhe3'
            this.mainRow={ORDDTTM:getDate('day'),STAFFNM:this.v_usernm,CRCY:'4238',STFG:'N','ORDTY':'PRE',ISTAX:'Y'}
            this.saveFlag=false
            this.dtlData=[]
            this.saveTag =true
        },
        //状态查询
        stfgChange(){
            this.qryTabData()
        },
 
        //获取表列字段
        getTabField(){
            let vm =this
            this.vueCol =[]
            this.tabArr =[]
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','17435','lstseq','2076','','',' order by sortby,lstseq').then((res) => {
                this.initCol =res.result
                return this.loadInitialFieldSettings().then(() => res)
            }).then(() => {
                this.vueCol =[]
                this.tabArr =[]
                const mainFields =this.sortFieldRows(this.initCol)
                for (let k=0; k<mainFields.length; k++){
                    const rowField =mainFields[k]
                    vm.tabArr.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(rowField, vm.$store.state.lang),
                        key: rowField.key,
                        align: rowField.align,
                        width: rowField.width,
                        thide:rowField.THIDE,
                        fhide:rowField.FHIDE,
                        edcss:rowField.EDCSS,
                        disabled:rowField.DISABLED,
                        dotnum:rowField.DOTNUM,
                    })
                    let itcol =rowField
                    if (itcol.THIDE=='N'){
                        let v_obj ={   //向数组的开头 添加序列号
                            field:itcol['key'] ,
                            title: vm.$translate.getColTitle(itcol, vm.$store.state.lang),
                            key: itcol['key']  ,
                            align: itcol.align,                                
                            width: Number(itcol.width),
                            thide:itcol.THIDE,
                            fhide:itcol.FHIDE,
                            sortable:false,
                            renderHeaderCell: ({column}, h) => {
                                if (itcol.EDCSS =='date'||itcol.EDCSS =='time') {
                                    return (                              
                                        <div >                   
                                            <div style="margin-top:3px;display:flex;white-space: nowrap;  " >
                                                <el-link underline={false} on-click={()=>{this.sortChange(column)} } style="font-size:12px;color:#03274b;font-weight:700">{column.title}</el-link>                                            
                                            </div> 
                                            <div style="display:flex">
                             
                                                <input  size="mini" pattern="yyyy-MM-dd"  value={this.v_inputrow[column.key]} type="date" on-keydown={()=>this.enterDown(event)} on-input={(e)=>{this.inputChg(e,column.key)}} style="padding:0px;margin-top:1px;width:100%;height:28px"> </input>              
                                            </div>
                                        </div>                                   
                                    )
                                }else{
                                    if (itcol.EDCSS =='number') {
                                        return (                              
                                            <div >
                                                <div style="margin-top:3px;display:flex;white-space: nowrap; " >
                                                    <el-link underline={false} on-click={()=>{this.sortChange(column)} } style="font-size:12px;color:#03274b;font-weight:700; ">{column.title}</el-link>                                                
                                                </div>                        
                                                <div style="display:flex">
                                                    <select  style="width:60px;background:white;height:28px;margin-top:1px" value={this.v_inputrow[`#OPER`+column.key]} on-change={(e)=>{this.inputChg(e,`#OPER`+column.key)}}>
                                                        <option    value="=" style="height:30px;line-height:30px">=</option>
                                                        <option    value=">" style="height:30px;line-height:30px">&gt;</option>
                                                        <option    value="<" style="height:30px;line-height:30px">&lt;</option>
                                                        <option    value="!=" style="height:30px;line-height:30px">!=</option>
                                                    </select>
                                                    <input disabled={itcol.EDCSS=='image'} value={this.v_inputrow[column.key]} on-keydown={()=>this.enterDown(event)} on-input={(e)=>{this.inputChg(e,column.key)}} style="padding:0px;margin-top:1px;width:100%;height:28px" size="mini"></input>
                                                </div>
                                            </div>                                   
                                        )
                                    }else{
                                        return (                              
                                            <div >
                                                <div style="margin-top:3px;display:flex;white-space: nowrap; " >
                                                    <el-link underline={false} on-click={()=>{this.sortChange(column)} } style="font-size:12px;color:#03274b;font-weight:700; ">{column.title}</el-link>                                                
                                                </div>                        
                                                <div style="display:flex">
                                                    <input disabled={itcol.EDCSS=='image'} value={this.v_inputrow[column.key]} on-keydown={()=>this.enterDown(event)} on-input={(e)=>{this.inputChg(e,column.key)}} style="padding:0px;margin-top:1px;width:100%;height:28px" size="mini"></input>
                                                </div>
                                            </div>                                   
                                        )
                                    }
                                }
                            },
                            disabled:itcol.DISABLED,
                            ellipsis: { showTitle: true, },
                            renderBodyCell: ({row,column,rowIndex},h) => {
                                let  rowVal =row[itcol['key'] ]
                                if (itcol.EDCSS=='image' ){
                                    return ( 
                                        <el-image fit="scale-down"  style="width:100%;height:30px; " src={rowVal} preview-src-list={[rowVal]}>
                                            <div   slot="error" ><i class="el-icon-picture-outline"></i></div>
                                        </el-image>
                                    )
                                }else if (column.key=='IDNO') { 
                                    return (                                           
                                        <el-link  underline={false} on-click={()=>{this.repBtn( row)}}><span style=" border-bottom:1px solid red;font-size:13px;;font-weight:700  " title={rowVal}>{rowVal}</span> </el-link>    
                                    )
                                } else if (column.key=='STFG') {                         
                                    if (row[itcol['key']] =='Y'){
                                        return (<el-tag   size="mini" type="success" effect="dark">{this.$LANG('1976', '已审核')}</el-tag> )
                                    }else if (row[itcol['key']] =='P'){
                                        return (<el-tag   size="mini" type="warning" effect="dark">{this.$LANG('1961', '审核中')}</el-tag> )
                                    }else if (row[itcol['key']] =='K'){
                                        return (<el-tag   size="mini" type="warning" effect="dark">{this.$LANG('1982', '已确认')}</el-tag> )
                                    }else {
                                        return (<el-tag   size="mini" type="info" effect="dark">{this.$LANG('2005', '未审核')}</el-tag> )
                                    }                                          
                                } else if (column.key=='ISTAX') {                         
                                    if (row[itcol['key']] =='Y'){
                                        return (<el-tag   size="mini" type="success" effect="dark">{this.$LANG('0283', '含税')}</el-tag> )
                                    }else {
                                        return (<el-tag   size="mini" type="info" effect="dark">{this.$LANG('0243', '不含')}</el-tag> )
                                    }                                          
                                }else{
                                    return row[itcol['key'] ]
                                }
                            },                                
                        }
                        this.vueCol.push(v_obj)
                    }
                }
                // 分组 字段
                let v_rownum ={
                    field: "index",
                    key: "rownum",
                    title: this.$LANG('0310', '序号'),
                    width: 55,
                    align: "center",
                    fixed:"left",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (<span style="color:#1890ff;">
                            {rowIndex + this.startRowIndex + 1}
                        </span> )
                    },
                    renderHeaderCell: ({column}, h) => {
                        return (  
                            <div >
                                <div style="margin-top:3px">{column.title}</div>
                                <el-link on-click={()=>{this.rowShow()}} style="font-size:12px;color:#404eff;height:30px"> 
                                    <el-tooltip content={this.$LANG('0852', ' 清除条件')} effect="light">
                                        <i class="iconfont icon-shanchu1"  ></i>
                                    </el-tooltip>
                                </el-link>
                            </div>
                        )
                    },
                }
                let v_oper ={
                    field: "oper0",
                    key: "oper",
                    title: this.$LANG('0330', '操作'),
                    width:200,
                    align: "center",
                    fixed:"right",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        if (row['STFG']=='N'){
                            return ( 
                                <div>
                                    <i class="iconfont icon-chakan" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link  on-click={()=>{this.editRec(row,'Y' )}}  underline={false} ><span style="font-size:12px;margin-right:5px">{this.$LANG('0139', '查看')}</span></el-link>
                                    <i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link  disabled={this.editBool} on-click={()=>{this.editRec(row,'N' )}}  underline={false} ><span style="font-size:12px;margin-right:5px">{this.$LANG('1639', '编辑')}</span></el-link>
                                    <i class="iconfont icon-shenhe" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link  disabled={this.delBool} on-click={()=>{this.recSet(row,'K', '确认')}}  underline={false} ><span style="font-size:12px;margin-right:5px">{this.$LANG('0364', '确认')}</span></el-link>
                                    <i class="iconfont icon-shanchu1" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link  disabled={this.delBool} on-click={()=>{this.recSet(row,'X','作废')}}  underline={false} ><span style="font-size:12px;margin-right:5px">{this.$LANG('0257', '作废')}</span></el-link>
                                </div>                                
                            )
                        }else if (row['STFG']=='K'){
                            return ( 
                                <div>    
                                    <i class="iconfont icon-chakan" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link  on-click={()=>{this.editRec(row,'Y',rowIndex)}}  underline={false} ><span style="font-size:12px;margin-right:5px">{this.$LANG('0139', '查看')}</span></el-link>
                                    <i class="iconfont icon-fanshenhe" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link  disabled={this.editBool} on-click={()=>{this.recSet(row,'N', '弃认')}}  underline={false} ><span style="font-size:12px;margin-right:5px">{this.$LANG('0314', '弃认')}</span></el-link>
                                    <i class="iconfont icon-shenhe" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link  disabled={this.cfmBool} on-click={()=>{this.recSet(row,'Y','审核')}}  underline={false} ><span style="font-size:12px;margin-right:5px">{this.$LANG('0134', '审核')}</span></el-link>
                                </div>                                
                            )
                        }else if (row['STFG'] =='P') { 
                            return ( 
                                <div>
                                    <i class="iconfont icon-chakan" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link   on-click={()=>{this.editRec(row,'Y',rowIndex )}}  underline={false} ><span style="font-size:12px;margin-right:5px;">{this.$LANG('0139', '查看')}</span></el-link>
 
                                </div>                                
                            )  
                        }else if (row['STFG']=='Y'){
                            return ( 
                                <div>    
                                    <i class="iconfont icon-chakan" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link  on-click={()=>{this.editRec(row,'Y',rowIndex)}}  underline={false} ><span style="font-size:12px;margin-right:5px">{this.$LANG('0139', '查看')}</span></el-link>
                                    <i class="iconfont icon-fanshenhe" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link  disabled={this.cfmBool} on-click={()=>{this.recSet(row,'N','弃审')}}  underline={false} ><span style="font-size:12px;margin-right:5px">{this.$LANG('0137', '弃审')}</span></el-link>
 
                                </div>                                
                            )
                        }
                    },
                }
                this.vueCol.unshift(v_rownum) 
                this.vueCol.push(v_oper)
                this.applyFieldSettingRows()
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','17435','lstseq','2077','','',' order by sortby,itmseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.dtlCol.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(res.result[k], vm.$store.state.lang),
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        notnull:res.result[k].NOTNULL,
                        sortable:res.result[k].SORTABLE,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','4272','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.prodCol.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(res.result[k], vm.$store.state.lang),
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss:res.result[k].EDCSS,
                        sortable:res.result[k].SORTABLE,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                    })
                }
            })
        }
    }
}
</script>
<style scoped lang="less">
 
    .active { 
        color: #389;
        border-bottom:3px solid #cc0000;
        margin-right:2px;
    }
    .oneMenu{
        display:flex;
        flex-direction:column;
        line-height:25px;
        background:white;
        margin-top:3px;
        font-size:13px;
        font-weight: 600;
    }
    .oneMenu:hover{
        cursor: pointer;
        color:#cc0000;
        background:#f7f8f9;
        font-weight:700;
    }
 
    .top{
        padding: 10px;
        background: rgba(0, 153, 229);
        color: #fff;
        text-align: center;
        font-size:10px;
        border-radius: 2px;
    }  
 
    .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 1px auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
    .item-width  {
        width: 32%;
        height: 22px;
    }
 
    .wraper{
        width:1250px;
        margin:1px auto;
    }
</style>
<style lang="less">
    .table-foot-cell-class {
        font-size: 12px !important;
        color: #03274b !important;
        background: #b2d3fa !important;
        font-weight:700 !important;
        padding: 2px !important;
        line-height: 25px !important;
        text-align:left !important;
        height: 15px !important;
   
    }
    .table-head-cell-class {
        font-size: 12px !important;
        color: #03274b !important;
        background: #e2e6eb !important;
        font-weight:700 !important;
        padding:0px !important;
        padding-top:4px !important;
        text-align:center !important;
        border-width: 1px !important;
        border-color: #808695 !important;
    }
    .table-head-cell-class2 {
        font-size: 12px !important;
        color: rgb(134, 4, 4) !important;
        background: #e2e6eb !important;
        font-weight:700 !important;
        border-width: 1px !important;
        border-color: #808695 !important;
        padding:6px !important;
    }
    .table-body-cell-class1 {
        font-size: 12px !important;
        color: black !important;
        border-width: 1px !important;
        padding:2px !important;
        border-color: #808695 !important;
        height:20px !important;
    }
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px !important;
            color:rgb(128,128, 128);
            font-size:12px;
        }
        td {
            padding: 5px ;
            font-size:11px;
        }   
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>
